import * as XLSX from "xlsx";
import {
  WsProduct,
  WsProductExportFormat,
  WsProductLinkScope,
} from "../../../api/webshop/wsProductsApi";

export interface WsProductLinkExportRow {
  productTitle: string;
  productName: string;
  countryName: string;
  productLink: string;
}

export const WS_PRODUCT_SITE_BASE = "https://www.sim-ply.io/esim";

export function buildWsProductSiteLink(
  productLink: string,
): string {
  return `${WS_PRODUCT_SITE_BASE}/${productLink}`;
}

function coverageList(product: WsProduct): string[] {
  if (product.coverageCountries && product.coverageCountries.length > 0) {
    return product.coverageCountries;
  }
  if (product.country) return [product.country];
  return [];
}

export function buildWsProductLinkRows(
  products: WsProduct[],
  scope: WsProductLinkScope,
): WsProductLinkExportRow[] {
  const rows: WsProductLinkExportRow[] = [];

  products.forEach((product) => {
    const countries = coverageList(product);
    const title = product.productTitle || product.title || "";
    const name = product.productName || "";

    if (scope === "ONE_PER_PRODUCT") {
      const countryName = countries[0] || "";
      rows.push({
        productTitle: title,
        productName: name,
        countryName,
        productLink:
          product.productLink || product.productId
            ? buildWsProductSiteLink(product.productLink || product.Id)
            : "",
      });
      return;
    }

    if (countries.length === 0) {
      rows.push({
        productTitle: title,
        productName: name,
        countryName: "",
        productLink: "",
      });
      return;
    }

    rows.push({
      productTitle: title,
      productName: name,
      countryName: "",
      productLink: product.productLink || product.productId ? buildWsProductSiteLink(product.productLink || product.productId) : "",
    });
  });

  return rows;
}

function toSheetRows(rows: WsProductLinkExportRow[]) {
  return rows.map((row) => ({
    productTitle: row.productTitle,
    productName: row.productName,
    countryName: row.countryName,
    productLink: row.productLink,
  }));
}

export function downloadWsProductLinkExport(
  rows: WsProductLinkExportRow[],
  format: WsProductExportFormat,
) {
  const sheet = XLSX.utils.json_to_sheet(toSheetRows(rows), {
    header: ["productTitle", "productName", "countryName", "productLink"],
  });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "Product Links");

  const date = new Date().toISOString().split("T")[0];
  const extension = format === "CSV" ? "csv" : "xlsx";
  const bookType = format === "CSV" ? "csv" : "xlsx";
  XLSX.writeFile(workbook, `webshop-product-links-${date}.${extension}`, {
    bookType,
  });
}
